<template>
    <div class="panel panel-default category-info">
        <div class="panel-body">
            <div class="row category-info-title-row">
                <div class="col-xs-3 col-sm-2 col-md-2">
                    <img :src="currentItemCategory.image_path"
                         class="img img-responsive"
                         :alt="'ALT_IMAGE_CATEGORY' | translate"
                    >
                </div>
                <div class="col-xs-9"
                     :class="infoDetailIsNotEmpty ? 'col-sm-7 col-md-8' : 'col-sm-10 col-md-10'"
                >
                    <h3>{{ 'CATEGORY_INFO_SECTION_TITLE' | translate }}</h3>
                    <h2>
                        {{ currentItemCategory.name }}
                        <span class="category-info-progress"
                              v-if="showCategoryProgress"
                        >
                            ({{ 'CATEGORY_INFO_ITEMS_COMPLETE' | translate }}
                            {{ categoryProgress(currentItemCategory.id).answered }}/{{ categoryProgress(currentItemCategory.id).total }})
                        </span>
                    </h2>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-2 category-info-btn-col"
                     v-show="infoDetailIsNotEmpty"
                >
                    <a v-if="!infoDetailVisible"
                       @click="infoDetailVisible = true"
                    >
                        {{ 'CATEGORY_INFO_SECTION_BTN_MORE' | translate }}
                        <i class="fa fa-chevron-down"></i>
                    </a>
                    <a v-else
                       @click="closeDetail"
                    >
                        {{ 'CATEGORY_INFO_SECTION_BTN_LESS' | translate }}
                        <i class="fa fa-chevron-up"></i>
                    </a>
                </div>
            </div>

            <div v-show="infoDetailVisible && infoDetailIsNotEmpty"
                 class="category-info-detail"
            >
                <h3 v-show="currentItemCategory.info_title">
                    {{ currentItemCategory.info_title }}
                </h3>

                <p v-html="currentItemCategory.info_content"
                   v-if="infoContentStripped"
                   class="info_content"
                >
                </p>

                <a :href="currentItemCategory.info_cta_url"
                   v-if="currentItemCategory.info_cta_url && currentItemCategory.info_cta_title"
                   target="_blank"
                >
                    {{ currentItemCategory.info_cta_title }}
                    <i class="fa fa-external-link"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
    import { mapGetters } from "vuex";

    export default {
        mounted : function() {
            this.openDetailOnUnseenCategory();
        },

        watch : {
            // if an item from a previously un-closed (unseen) category shows up, we want to show the
            // category detail
            currentItemCategory() {
                this.openDetailOnUnseenCategory();
            }
        },

        computed : {
            ...mapGetters(["currentItemCategory", "categoryProgress"]),

            // strip tags and empty spaces from the infoContent to determine whether it's actually empty.
                // It can contain empty content such as <p><br/> &nbsp;<p> etc.
            infoContentStripped() {
                let infoContent = null;
                if (this.currentItemCategory.info_content) {
                    infoContent = this.currentItemCategory.info_content.replace(/<\/?[^>]+(>|$)/g, "");
                    infoContent = infoContent.replace(/&nbsp;| /g, "");
                }
                return infoContent;
            },

            // check all "info" fields of category to see if there is any additional detail that can be shown
            infoDetailIsNotEmpty() {
                return !!(
                    (this.currentItemCategory.info_title && this.currentItemCategory.info_title.length > 0)
                    || (this.currentItemCategory.info_cta_title && this.currentItemCategory.info_cta_title.length > 0)
                    || (this.infoContentStripped && this.infoContentStripped.length > 0)
                );
            }
        },

        data() {
            return {
                infoDetailVisible    : false,
                showCategoryProgress : config.features.showCategoryProgress
            };
        },

        methods : {
            openDetailOnUnseenCategory() {
                if (this.currentItemCategory.id === undefined) {
                    return;
                }

                // if this user hasn't seen the detail of this category yet, show the full details.
                // Otherwise, close the detail - this can happen on transition from open detail to a new
                // item from previously closed (seen) category.
                // @note: if the info detail is empty (see computed infoDetailIsNotEmpty), none of this matters.
                const seenCategories = JSON.parse(localStorage.getItem("seenCategoryDetails")) || [];
                this.infoDetailVisible = seenCategories.indexOf(this.currentItemCategory.id) === -1;
            },

            closeDetail() {
                this.infoDetailVisible = false;

                // store the fact that the user has already seen this category detail so that it's closed
                // by default next time the component is mounted
                // @note: if the info detail is empty (see computed infoDetailIsNotEmpty), none of this matters.
                let seenCategories = JSON.parse(localStorage.getItem("seenCategoryDetails")) || [];

                if (seenCategories.indexOf(this.currentItemCategory.id) === -1) {
                    seenCategories.push(this.currentItemCategory.id);
                }

                localStorage.setItem("seenCategoryDetails", JSON.stringify(seenCategories));
            }
        }
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
